export const FREQUENCY_UNITS = {
  MHZ: 'mhz',
  GHZ: 'ghz'
} as const;

export type FrequencyUnit = (typeof FREQUENCY_UNITS)[keyof typeof FREQUENCY_UNITS];

export const FREQUENCY_RANGES = {
  [FREQUENCY_UNITS.MHZ]: {
    min: 50,
    max: 999
  },
  [FREQUENCY_UNITS.GHZ]: {
    min: 1.2,
    max: 8.5
  }
} as const;

export interface IFrequencyRange {
  min: number;
  max: number;
}

export const getFrequencyRange = (unit: FrequencyUnit): IFrequencyRange => {
  return FREQUENCY_RANGES[unit];
};
